<ion-card>
  <ion-card-header>
    <ion-toolbar>
      <ion-icon slot="start" size="large" name="help-outline"></ion-icon>
      <ion-title>Questionari</ion-title>
      <ion-buttons slot="end">
        <ion-button fill="solid" color="secondary" (click)="onQuestionnaireAddClick()">
          Aggiungi
          <ion-icon slot="start" name="add-circle-outline"></ion-icon>
        </ion-button>
      </ion-buttons>
    </ion-toolbar>
  </ion-card-header>
  <ion-card-content>
    <table
      mat-table
      [dataSource]="rows()"
      matSort
      [matSortActive]="query()?.sortBy"
      [matSortDirection]="query()?.sortDirection"
      (matSortChange)="onSortChange($event)"
      class="w-100 mat-elevation-z1"
    >
      <!-- Name -->
      <ng-container matColumnDef="NAME">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Nome</th>
        <td mat-cell *matCellDef="let row">
          {{ row.modelName }}
        </td>
      </ng-container>

      <!-- Start Date -->
      <ng-container matColumnDef="startDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Data inizio</th>
        <td mat-cell *matCellDef="let row">
          {{ row.startDate | date: "dd/MM/yyyy" }}
        </td>
      </ng-container>

      <!-- End Date -->
      <ng-container matColumnDef="endDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Data fine</th>
        <td mat-cell *matCellDef="let row">
          {{ row.endDate | date: "dd/MM/yyyy" }}
        </td>
      </ng-container>

      <!-- Frequency -->
      <ng-container matColumnDef="frequency">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Frequenza</th>
        <td mat-cell *matCellDef="let row">
          {{ row.frequencyLabel }}
        </td>
      </ng-container>

      <!-- Subcontext -->
      <!-- <ng-container matColumnDef="subcontext">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Sottocontesto</th>
        <td mat-cell *matCellDef="let row">
          {{ row.subcontext }}
        </td>
      </ng-container> -->

      <!-- Subgroups -->
      <!-- <ng-container matColumnDef="subgroups">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Sottogruppi</th>
        <td mat-cell *matCellDef="let row">
          {{ row.subgroups }}
        </td>
      </ng-container> -->

      <!-- Status -->
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Stato</th>
        <td mat-cell *matCellDef="let row">
          @if (row.active) {
            <ion-icon
              style="font-size: 24px"
              class="app-icon"
              [src]="'check-circle-outline' | getIcon"
              color="success"
              c3Tooltip="Attivo"
            ></ion-icon>
          } @else {
            <ion-icon
              style="font-size: 24px"
              class="app-icon"
              name="close-circle-outline"
              c3Tooltip="Attivo"
              color="danger"
              c3Tooltip="Inattivo"
            ></ion-icon>
          }
        </td>
      </ng-container>

      <!-- Header -->
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>

      <!-- Rows -->
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

      <!-- Empty State -->
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" [attr.colspan]="displayedColumns.length">
          Nessun questionario trovato
        </td>
      </tr>
    </table>

    <mat-paginator
      [length]="total()"
      [pageIndex]="query()?.page"
      [pageSize]="query()?.size"
      [pageSizeOptions]="[10, 25, 50, 100]"
      [disabled]="loading()"
      (page)="onPageChange($event)"
    >
    </mat-paginator>
  </ion-card-content>
</ion-card>
